import {connect} from 'react-redux';
import axios from 'axios';
import {Platform} from "react-native";
import DetailsRequestScreen from "../DetailsRequestScreen";
import store from "../../../../../redux/store";
import {typeExport} from "../../../../../redux/store/type";
import * as NavigationService from "../../../../../redux/NavigationService";
import HMAlert from "../../../../../customviews/HMAlert";
import i18n from "../../../../../I18n/i18n";


const mapStateToProps = (state) => ({
    results: state.reducerDetailsRequestScreen.results,
    isLoading: state.reducerDetailsRequestScreen.isLoading,
    NoInternetDialog: state.reducerDetailsRequestScreen.NoInternetDialog,

    resultsSet: state.reducerDetailsRequestScreen.resultsSet,
    isLoadingSet: state.reducerDetailsRequestScreen.isLoadingSet,
    NoInternetDialogSet: state.reducerDetailsRequestScreen.NoInternetDialogSet,

    position: state.reducerDetailsRequestScreen.position,
    id_category: state.reducerDetailsRequestScreen.id_category,


    positionPersonnel: state.reducerDetailsRequestScreen.positionPersonnel,
    id_Personnel: state.reducerDetailsRequestScreen.id_Personnel,

    CartList: state.reducerSplashGetAllData.CartList,
    PriceAll: state.reducerSplashGetAllData.PriceAll,

    user: state.reducerSplashGetAllData.user,
    token: state.reducerSplashGetAllData.token,
    wallet: state.reducerSplashGetAllData.wallet,
    //data_splash: state.reducerSplashGetAllData,
    DataSplashScreen: state.reducerSplashGetAllData,
    // token: state.reducerSplash.token,

    FoodItem: state.reducerSplashGetAllData.FoodItem,
});

const mapDispatchToProps = (dispatch) => ({
    callService: (url, params, type, typeConnection, token) => dispatch(callWebservice(url, params, type, typeConnection, token)),

    callserviceActionRefresh: (user) => dispatch(serviceActionRefresh(user)),

});

const getDataDisatch = (dispatch, url, params, type, typeConnection, token) => {

    switch (type) {
        case typeExport.TypeGetDetailsRequestScreen:
            dispatch(serviceActionPending());

            break;

        case typeExport.TypeSetDetailsRequestScreen:
            dispatch(serviceActionPendingSet());

            break;

        default:
    }


    var config = {
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        responseType: 'blob'
    };
    let formData = new FormData();
    formData.append('_operation', params._operation);
    // // formData.append('lang', params.lang);
    formData.append('mode', params.mode);
    formData.append('customValue', params.customValue);
    //   formData.append('state_params', params.state_params);
    formData.append('_session', params._session == null ? '' : params._session);
    formData.append('shahrvand', true);
    /*  axios(
          {
              url:  url + params,
              method: typeConnection,
              headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
              },
              timeout: typeExport._TIMEOUT,
              /!*      headers: {'X-Requested-With': 'XMLHttpRequest'},*!/
          }
      )*/
    axios.post(url, formData, config)
        .then(response => {
            let data = response.data;
            switch (type) {
                case typeExport.TypeGetDetailsRequestScreen:
                    if (response.data.status === true) {
                        // dispatch(serviceActionSuccess(data, token, response.data.user));
                        dispatch(serviceActionSuccess(data, token, ""));
                        NavigationService.navigateParams("SubmitSwitchingOperationScreen", {
                            item: params.state_params,
                            res: data
                        })
                        //   NavigationService.navigatereset('MainStack');
                    }
                    else {
                        HMAlert(
                            i18n.t('constant.message'),
                            response.data.message ? response.data.message : "مجددا تلاش نمایید سرور با مشکل مواجه شد",
                            [
                                // {text: 'Ask me later', onPress: () => {}},
                                {
                                    text: i18n.t('constant.ok'), onPress: () => {

                                        //    NavigationService.navigatereset("ApplyScreen", {item: item})
                                    }
                                    //  NavigationService.navigatereset("ApplyScreen",{item: item})

                                    , style: 'cancel'
                                },

                            ],
                            {cancelable: true}
                        )
                        dispatch(serviceActionError(data))
                        //   NavigationService.navigatereset('LoginStack');
                    }
                    break;

                case typeExport.TypeSetDetailsRequestScreen:

                    break;

                default:
            }
        }).catch((e) => {
        HMAlert(
            i18n.t('constant.message'),
            response.data.message ? response.data.message : "مجددا تلاش نمایید سرور با مشکل مواجه شد",
            [
                // {text: 'Ask me later', onPress: () => {}},
                {
                    text: i18n.t('constant.ok'), onPress: () => {

                        //    NavigationService.navigatereset("ApplyScreen", {item: item})
                    }
                    //  NavigationService.navigatereset("ApplyScreen",{item: item})

                    , style: 'cancel'
                },

            ],
            {cancelable: true}
        )
        switch (type) {
            case typeExport.TypeGetDetailsRequestScreen:
                dispatch(serviceActionError(e))

                break;

            case typeExport.TypeSetDetailsRequestScreen:
                dispatch(serviceActionErrorSet(e))

                break;

            default:
        }
    })
}


// export const callSetStateCity =  (state_name,state_id,city_name,city_id)  => {

//     return dispatch (serviceActionSuccessSetCityStateData (state_name,state_id,city_name,city_id) )
// }
export const callWebservice = (url, params, type, typeConnection, token) => {
    return dispatch => {
        //
        // // if (Platform.OS === 'ios') {
        // //     NetInfo.isConnected.addEventListener('connectionChange', (isConnected) => {
        // //             if (isConnected) {
        // //                 getDataDisatch(dispatch, url, params, type, typeConnection, token);
        // //             }
        // //             else {
        // //                 dispatch(serviceActionError("No Internet Connection"));
        // //             }
        // //         }
        // //     );
        // // }
        // // else {
        //     NetInfo.isConnected.fetch().then(isConnected => {
        //         if (isConnected) {
        //             getDataDisatch(dispatch, url, params, type, typeConnection, token);
        //         }
        //         else {
        //             switch (type) {
        //
        //                 case TypegetDetailsRequestScreen:
        //                     dispatch(serviceActionError("no connect"));
        //                     break;
        //                 default:
        //             }
        //         }
        //     });
        // //}

        // NetInfo.getConnectionInfo().done(
        //     (isConnected) => {
        //         if (isConnected) {
        //             getDataDisatch(dispatch, url, params, type, typeConnection, token);
        //         }
        //         else {
        //             switch (type) {
        //
        //                 case typeExport.TypeGetDetailsRequestScreen:
        //                     dispatch(serviceActionError("no connect"));
        //                     break;
        //                 default:
        //             }
        //         }
        //     }
        // )

        if (store.getState().reducerSplashGetAllData.Connection) {
            getDataDisatch(dispatch, url, params, type, typeConnection, token);
        }
        else {
            switch (type) {
                case typeExport.TypeGetDetailsRequestScreen:
                    dispatch(serviceActionError('error_Connection'))

                    break;

                case typeExport.TypeSetDetailsRequestScreen:
                    dispatch(serviceActionErrorSet('error_Connection'))

                    break;

                default:
            }
        }

    }
}


export const serviceActionPending = () => ({
    type: typeExport.DetailsRequestScreen_SERVICE_PENDING,
    NoInternetDialog: false,
    isLoading: true,
    showDialohCity: false

})

export const serviceActionError = (error) => ({
    type: typeExport.DetailsRequestScreen_SERVICE_ERROR,
    NoInternetDialog: true,
    error: error,
    isLoading: false,
    showDialohCity: false

})

export const serviceActionSuccess = (data) => ({
    type: typeExport.DetailsRequestScreen_SERVICE_SUCCESS,
    NoInternetDialog: false,
    results: data,
    isLoading: false,
})

export const serviceActionPendingSet = () => ({
    type: typeExport.DetailsRequestScreen_SERVICE_PENDING_Set,
    NoInternetDialogSet: false,
    isLoadingSet: true,

})

export const serviceActionErrorSet = (error) => ({
    type: typeExport.DetailsRequestScreen_SERVICE_ERROR_Set,
    NoInternetDialogSet: true,
    error: error,
    isLoadingSet: false,

})

export const serviceActionSuccessSet = (data) => ({
    type: typeExport.DetailsRequestScreen_SERVICE_SUCCESS_Set,
    NoInternetDialogSet: false,
    resultsSet: data,
    isLoadingSet: false,
})
export const serviceActionRefresh = () => ({
    type: typeExport.DetailsRequestScreen_SERVICE_REFRESH,
    NoInternetDialog: false,
    results: null,
    isLoading: false,
})


export default connect(mapStateToProps, mapDispatchToProps)(DetailsRequestScreen);
